import { take, fork, put, call, delay } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { failLogin, successLogin, logout, successRecovery, failRecovery } from "../actionCreators/authentication";
import v from "../../validators/GlobalValidator";
import { callApi } from "./callApi";
import { requestClubList, requestClubsInfo } from "../actionCreators/club";
import { showNotification } from "../actionCreators/notification";
import { saveUser, clearToken } from "./helpers/localStorage";
import config from '../../config/config';
import { requestDailyBonus } from '../actionCreators/bonus';

function* makeLogin({ username, password, skinId, token, isAuthCheck  }) {
    console.log('makeLogin: username: ', username);
    try {
        if (password) {
            let validation = v.validateAuthentication({ username, password });
            if (!validation.success) {
                yield put(failLogin({ loginError: validation.error }));
                return;
            }
        }
        const params = { username, skinId };
        if( !!token ) {
            params.token = token;
        } else {
            params.password = password;
        }
        const response = yield call(callApi, `${config.API_URL}/club/authenticate`, 'POST', params);
        const authData = response.data.result.authenticationData;
        yield put(successLogin({ authenticated: true, accounts: authData }));
        saveUser(response.data.result, !isAuthCheck);
        yield put(requestClubList(authData));
        yield put(requestClubsInfo());
        if( !isAuthCheck ) yield put(requestDailyBonus());
    } catch (e) {
        if( !!e && !!e.response && !!e.response.data ) {
            yield put(failLogin({ loginError: e.response.data }));
        }
    }
}

function* registerUser( userData ) {
    console.log('registerUser: userData: ', userData);
    try {
        let validation = v.validateRegistration(userData);
        if (!validation.success) {
            return put(failLogin({ registrationError: validation.error }));
        }
        const response = yield call(callApi, `${config.API_URL}/club/globalAccount`, 'POST', userData);
        const authData = response.data.result.authenticationData;
        yield put(successLogin({ authenticated: true, accounts: authData }));
        saveUser(response.data.result, true);
        yield put(requestClubList(authData));
        yield put(requestClubsInfo());
        yield put(requestDailyBonus());
    } catch (e)  {
        if(!!e && !!e.response && !!e.response.data) {
            yield put(failLogin({ registrationError: e.response.data }));
        }
    }
}

function* checkAuthentication() {
    console.log('checkAuthentication: SAGA');
    try {
        let storedAuth =  localStorage.authenticationData && JSON.parse(localStorage.authenticationData).authenticationData,
            currentTime = new Date().getTime() / 1000;

        if (!!storedAuth && storedAuth.length > 0) {
            if (currentTime < localStorage.expDate) {
                const {username, clubId: skinId, token} = storedAuth.find(acc=>acc.isGlobal);
                const params = { username, skinId, token };
                const response = yield call(callApi, `${config.API_URL}/club/refreshAccounts`, 'POST', params);
                const authData = response.data.result.authenticationData;
                yield put(successLogin({ authenticated: true, accounts: authData }));
                saveUser(response.data.result, false);
                yield put(requestClubList(authData));
                yield put(requestClubsInfo());
            } else {
                console.log('token is expired, logging out..');
                yield put(logout());
            }
        } else {
            yield put(logout());
        }
    } catch (e) {
        yield put(failLogin({ loginError: e }));
    }
}

function* passwordRecovery( userData ) {
    try {
        let validation = v.validateForgotPassword(userData);
        if (!validation.success) {
            return put(failLogin({ recoveryError: validation.error }));
        }
        const response = yield call(callApi, `${config.API_URL}/club/globalAccount`, 'POST', userData);
        const authData = response.data.result.authenticationData;
        yield put(successRecovery({ authenticated: true, accounts: authData }));
    } catch (e) {
        if(!!e && !!e.response && !!e.response.data) {
            yield put(failRecovery({ recoveryError: e.response.data }));
        }
    }
}

export function* watchLogin() {
    while (true) {
        const action = yield take(actionTypes.LOGIN_REQUEST);
        yield fork(makeLogin, action.value);
    }
}

export function* watchRegister() {
    while (true) {
        const action = yield take(actionTypes.REGISTER_REQUEST);
        yield fork(registerUser, action.value);
    }
}

export function* watchLogout() {
    while (true) {
        yield take(actionTypes.USER_LOGOUT);
        clearToken();
    }
}

export function* watchCheckAuthentication() {
    while (true) {
        yield take([ actionTypes.CHECK_AUTHENTICATION, actionTypes.CHANGE_CLUB_SUCCESS,
            actionTypes.BALANCE_TRANSFER_SUCCESS, actionTypes.CREATE_CLUB_SUCCESS, actionTypes.DISBAND_CLUB_SUCCESS,
            actionTypes.CREATE_UNION_SUCCESS, actionTypes.DISBAND_UNION_SUCCESS, actionTypes.QUIT_MEMBER_CLUB_SUCCESS ]);
        yield fork(checkAuthentication);
    }
}

export function* checkAuthenticationByInterval() {
    while (true) {
        yield fork(checkAuthentication);
        yield delay(config.fetchDataIntervals.auth);
    }
}

export function* watchPasswordRecovery() {
    while (true) {
        const action = yield take(actionTypes.PASSWORD_RECOVERY_REQUEST);
        yield fork(passwordRecovery, action.value);
    }
}
